import * as types from "../actions/actionTypes";
import initialState from "./initialState";

//-- Remember, an action can be handled by multiple reducers and a reducer can be used by multiple handlers (many to many relationship)

function actionTypeEndsInSuccess(type) {
	return type.substring(type.length - 8) === "_SUCCESS";
}

export default function apiCallStatusReducer(state = initialState.apiCallsInProgress, action) {
	if (action.type == types.BEGIN_API_CALL) {
		return state + 1;
	} else if (action.type === types.API_CALL_ERROR || actionTypeEndsInSuccess(action.type)) {
		return state - 1;
	}

	return state;
}
